// Notification store for managing toast messages

export interface Notification {
	id: string;
	message: string;
	type: 'success' | 'error' | 'warning' | 'info';
	duration?: number;
}

class NotificationStore {
	private state = $state<Notification[]>([]);

	// Get current notifications
	get notifications() {
		return this.state;
	}

	// Add a notification
	add(notification: Omit<Notification, 'id'>) {
		// Generate UUID that works in all browsers
		const id = crypto?.randomUUID?.() || Math.random().toString(36).substr(2, 9);
		const newNotification: Notification = {
			id,
			duration: 5000, // Default 5 seconds
			...notification,
		};

		this.state = [...this.state, newNotification];
		return id;
	}

	// Remove a notification
	remove(id: string) {
		this.state = this.state.filter((n) => n.id !== id);
	}

	// Clear all notifications
	clear() {
		this.state = [];
	}

	// Convenience methods
	success(message: string, duration?: number) {
		return this.add({ message, type: 'success', duration });
	}

	error(message: string, duration?: number) {
		return this.add({ message, type: 'error', duration });
	}

	warning(message: string, duration?: number) {
		return this.add({ message, type: 'warning', duration });
	}

	info(message: string, duration?: number) {
		return this.add({ message, type: 'info', duration });
	}
}

export const notificationStore = new NotificationStore();
